import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';
import { LogOut, Home } from 'lucide-react';

const AdminLayout = ({ children, title }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-brand-soft">
      {/* Header */}
      <div className="bg-white border-b border-brand-accent">
        <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex items-center justify-between">
            {/* Logo e Título */}
            <div className="flex items-center space-x-2 sm:space-x-4 flex-1 min-w-0">
              <Link to="/admin/dashboard" className="flex-shrink-0">
                <img 
                  src="/logo-ybp.png" 
                  alt="Your Broker Portugal" 
                  className="h-8 sm:h-12 w-auto cursor-pointer"
                />
              </Link>
              <div className="hidden sm:block">
                <h1 className="text-lg sm:text-xl font-display font-semibold text-brand-text">Painel Admin</h1>
                <p className="text-xs sm:text-sm text-brand-text-secondary">Bem-vindo, {user?.name || 'Admin'}</p>
              </div>
            </div>
            
            {/* Botões - Mobile e Desktop */}
            <div className="flex items-center space-x-1 sm:space-x-4">
              <Button asChild variant="outline" size="sm" className="hidden sm:flex border-brand-primary text-brand-primary hover:bg-brand-primary hover:text-white">
                <Link to="/">
                  <Home className="w-4 h-4 mr-2" />
                  Ver Site
                </Link>
              </Button>
              <Button asChild variant="outline" size="sm" className="sm:hidden p-2">
                <Link to="/">
                  <Home className="w-4 h-4" />
                </Link>
              </Button>
              
              <Button onClick={handleLogout} variant="outline" size="sm" className="hidden sm:flex">
                <LogOut className="w-4 h-4 mr-2" />
                Sair
              </Button>
              <Button onClick={handleLogout} variant="outline" size="sm" className="sm:hidden p-2">
                <LogOut className="w-4 h-4" />
              </Button>
            </div>
          </div>
          
          {/* Mobile Title */}
          <div className="sm:hidden mt-2">
            <h1 className="text-base font-display font-semibold text-brand-text">Painel Admin</h1>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 sm:px-6 py-4 sm:py-8">
        {title && (
          <div className="mb-4 sm:mb-6">
            <Link to="/admin/dashboard" className="text-xs sm:text-sm text-brand-primary hover:text-brand-primary-hover mb-2 inline-block">
              ← Voltar ao Dashboard
            </Link>
            <h2 className="text-2xl sm:text-3xl font-display font-light text-brand-text">{title}</h2>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;
